const TOUR_BLOCKER_SELECTOR = "[data-help-tour-blocker]";

export function isHelpTourBlocked() {
  return Boolean(document.querySelector(TOUR_BLOCKER_SELECTOR));
}
